import { brand } from '@alison/ui';
import ButtonBase from '@mui/material/ButtonBase';
import type { ReactNode } from 'react';
import sparkle from '../../assets/ai-insights/sparkle.svg';
import { VIOLET_TINT } from './InsightsCharts.js';

export function AiInsightsChip({
  label,
  open,
  onToggle,
}: {
  label: string;
  open: boolean;
  onToggle: () => void;
}): ReactNode {
  return (
    <ButtonBase
      aria-expanded={open}
      onClick={onToggle}
      sx={{
        gap: 0.5,
        px: 2,
        py: 0.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: brand.violet,
        bgcolor: open ? VIOLET_TINT : 'transparent',
        color: brand.violet,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 'normal',
        whiteSpace: 'nowrap',
        '&.Mui-focusVisible': {
          outline: '2px solid',
          outlineColor: brand.violet,
          outlineOffset: 2,
        },
      }}
    >
      <img src={sparkle} alt="" />
      {label}
    </ButtonBase>
  );
}
